import styled from './primeiroacesso.module.css';
import { onlynumber, Alerta } from '../../utils/functions';
import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import { toast } from 'react-toastify';


function PrimeiroAcesso() {

    const [cgccli, setCgccli] = useState('');
    const [email, setEmail] = useState('');
    const { setStatus,setCgcglobal } = useContext(AuthContext);
    const Navigate = useNavigate();
    const [loading,setLoading] = useState(false);

    //Funcao de primrio acesso na api*********************************************
    async function Acesso() {
        setLoading(true);
        await api.get(`acesso/?cgccli=${cgccli}&email=${email}`)
            .then((response) => {
                if (!response.data.msg) {
                    if (!response.data.errocod) {
                        setCgcglobal(cgccli); //Grava cgc para ser usado na verificacao
                        setLoading(false);
                        toast.success('Código enviado com sucesso !!!');
                        setStatus('verifica');
                        Navigate('/Verificacao');
                    }else{
                        Alerta('Erro!',response.data.errocod,'error');
                        setLoading(false);
                        setStatus('');
                        Navigate('/');
                    }
                } else {
                    setLoading(false);
                    setStatus('erro');
                    Navigate('/Erroacesso');
                }

            }).catch((erro) => {
                Alerta('Erro!', erro.response.data, 'error');
                setLoading(false);
            })
    }
    //***************************************************************************



    return (
        <div className={styled.pagelogin}>
            <div className={styled.frame101}>
                <div className={styled.logo}>
                    <div className={styled.logoimg}></div>
                </div>
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a className={styled.titletext}>Primeiro Acesso</a>
                            <div className={styled.titletextline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.appprimeiroacesso}>
                            <a className={styled.titletext2}>Para acessar a área do cliente pela primeira vez é necessário informar o CNPJ
                                da sua empresa e o endereço de email informado no momento da compra. Dúvidas entrar em contato com (17) 97400-4099</a>
                            <div className={styled.frame99}>
                                <div className={styled.frame100}>
                                    <label>CNPJ<a>*</a></label>
                                    <input type='cnpj' onKeyPress={onlynumber}
                                        value={cgccli} onChange={(e) => setCgccli(e.target.value)} />
                                </div>
                                <div className={styled.frame102}>
                                    <label>Email<a>*</a></label>
                                    <input type='email'
                                        value={email} onChange={(e) => setEmail(e.target.value)} />
                                    <a>Você precisa ter acesso à caixa de entrada desse e-mail para copiar o código</a>
                                </div>

                            </div>
                            <div className={styled.framebtn}>
                                <button disabled={loading} onClick={() => Acesso()} className={styled.framebtnacesso}>
                                  {loading==true ? 'ENVIANDO...'  : 'ENVIAR CÓDIGO DE ATIVAÇÃO'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PrimeiroAcesso;